<template>
  <div class="my-class">
    <div v-for="item in items" :class="{ 'circle circle__dark': !isLight, 'circle circle__light': isLight }"></div>
  </div>
</template>

<script>
 import MyAccount from '../features/account/index'
/**
   * Placeholder for password on {@link MyAccount}
   */
export default {
  name: 'BasePasswordPlaceholder',
  props: {
    amountOfCircles: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      items: new Array(parseInt(this.amountOfCircles))
    }
  },
  computed: {
    isLight () {
      return this.color === 'light'
    }
  }
}
</script>

<style scoped lang="scss">

  .circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;

    &__dark {
      background: $rfx-dark-march;
    }

    &__light {
      background: $rfx-light-march;
    }
  }
  .circle:not(:last-child) {
    margin-right: 10px;
  }
</style>
